// eslint-disable-next-line no-restricted-imports
import styled from 'styled-components';

export const LoginCard = styled.div`
  animation-duration: 1s;
  animation-name: login-fade-in;
  background-color: #fff;
  border: 1px solid #ebebeb;
  border-radius: 12px;

  max-width: 420px;
`;

export const LoginContainer = styled.div`
  margin: 40px auto 20px;
  max-width: 420px;
`;

export const InputStyle = styled.input`
  border: none;
  font-size: 16px;
  font-weight: 300;
  height: 40px;
  line-height: 1.428571429;
  margin: 0;
  padding-left: 5px;
  padding-right: 5px;
  width: 100%;

  &:focus {
    border: none;
    border-radius: 6px;
    outline: none;
  }
`;

export const InputGroup = styled.div<{ hasError: boolean }>`
  align-items: stretch;
  background-color: #fff;
  background-color: transparent;
  border: 1px solid #d7d7d7;

  border-radius: 0;
  box-shadow: none;
  display: flex;
  position: relative;
  transition: box-shadow 0.2s ease-out 0.1s, border 0.2s ease-out, border-radius 0.2s ease-out,
    background-color 0.8s ease-out, color 0.1s ease-out, transform 0.1s ease-out;

  width: 100%;

  &:focus-within {
    -moz-box-shadow: 0px 0px 0px 2px rgba(34, 130, 255, 0.65);
    -webkit-box-shadow: 0px 0px 0px 2px rgba(34, 130, 255, 0.65);
    border-radius: 6px;
    box-shadow: 0px 0px 0px 2px rgba(34, 130, 255, 0.65);
  }

  ${({ hasError }) =>
    hasError &&
    `
    border: 1px solid #c62323
  `}
`;

export const InputLabel = styled.label`
  color: #616161;
  font-size: 14px;
  font-weight: 300;
  margin: 0 0 3px 6px;
`;

export const CustomButton = styled.button`
  background-color: #0050dc;
  border: 1px solid transparent;
  border-color: #0050dc;
  border-radius: 6px;
  color: #fafafa;
  display: block;
  font-size: 16px;
  font-size: 16px;
  margin-bottom: 18px;
  padding-bottom: 18px;
  padding-top: 18px;
  width: 100%;
`;

export const CustomLink = styled.a`
  color: #0050dc;
  font-family: Soleil;
  font-weight: 400;
  text-decoration: none;

  &:hover {
    display: inline-block;
    text-decoration: underline;
    transform-origin: bottom right;
  }
`;

export const SignupCTA = styled.div`
  animation-duration: 1s;
  animation-name: login-fade-in;
  background-color: #fff;
  border: 1px solid #ebebeb;
  border-radius: 12px;
  display: flex;
  font-family: Soleil;
  margin-top: 20px;
  overflow: hidden;
  padding: 0;
`;

export const AddOnGroup = styled.span`
  background-color: transparent;
  border: none;
  box-sizing: content-box;
  color: #616161;
  font-size: 0.85em;
  margin: auto;
  min-width: 20px;
  padding: 0 8px;
  position: relative;
  text-align: center;
  transition: background-color 0.1s ease-out;
  vertical-align: middle;
  z-index: 1;

  :before {
    background-color: #ebebeb;
    border-radius: 15px;
    content: '';
    display: block;
    height: 30px;
    left: 3px;
    margin-top: -15px;
    position: absolute;
    right: 3px;
    top: 50%;
    z-index: -1;
  }
`;

export const LabelCheckbox = styled.label`
  color: #000;
  cursor: pointer;
  font-family: Soleil, Helvetica Neue, Helvetica, Arial, sans-serif;
  font-size: 16px;
  font-weight: 400;
  margin: 0;
  padding-left: 8px;
`;
